module.exports = __webpack_public_path__ + "static/media/plus.b0421873.svg";